import React, { createContext, useContext } from "react";
import { useRenewalForecastSummary } from "../hooks";

const ForecastContext = createContext();

export const ForecastProvider = ({ children }) => {
  const forecastData = useRenewalForecastSummary();

  return (
    <ForecastContext.Provider value={forecastData}>
      {children}
    </ForecastContext.Provider>
  );
};

export const useForecastContext = () => {
  const context = useContext(ForecastContext);
  if (!context) {
    throw new Error(
      "useForecastContext must be used within a ForecastProvider",
    );
  }
  return context;
};
